export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0058.b701a0d2.webp";